module.exports = __webpack_public_path__ + "img/reject.123afa99.svg";